import { Pipe, PipeTransform} from '@angular/core';


@Pipe({
    name: 'firstLetterPipe',
    standalone: false
})

export class FirstLetterPipe implements PipeTransform {
    
    transform(userLogin: string):  string {
       
        return '' + userLogin.charAt(0).toLowerCase();
    }
}